// Do not import files that are not in the config/ folder, because it can break the website service
import posthog from "posthog-js";
import {PostHogProvider} from "posthog-js/react";
import {ReactElement} from "react";

export const PostHog = ({
  children,
  noeApiUrl,
  apiKey,
}: {
  children: ReactElement;
  noeApiUrl: string;
  apiKey?: string;
}) => {
  const postHogIsConfigured = apiKey && apiKey !== "";

  const endpoint =
    process.env.NODE_ENV === "production" ? `${noeApiUrl}/proxy` : "http://localhost:4010";

  return postHogIsConfigured ? (
    <PostHogProvider
      apiKey={apiKey}
      options={
        {
          api_host: `${endpoint}/all-gentle-spies-on-me`,
          ui_host: "https://eu.posthog.com",
          cookieless_mode: "always",
          disable_surveys: true,
          defaults: "2025-05-24",
        } as const
      }>
      {children}
    </PostHogProvider>
  ) : (
    children
  );
};

export const changePosthogUser = (user?: {
  email: string;
  firstName: string;
  lastName: string;
  locale: string;
  _id: string;
}) => {
  if (!user?.email) return posthog.reset(); // reset user if none given

  posthog.identify(user._id, {
    email: user.email,
    name: `${user.firstName} ${user.lastName}`,
    locale: user.locale,
    hedgehog_name: user.email,
  });
};
